import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GooglePatternNumberFormatter } from '../../services/google-pattern-number-formatter';

@Component({
    selector: 'google-adwords-conversion',
    templateUrl: './google-adwords-conversion.component.html'
})
export class GoogleAdwordsConversionComponent implements OnInit {
    @Input('offer') offer;
    protected sendTo: string = null;
    public conversionData: any;

    constructor(
        protected activatedRoute: ActivatedRoute,
        protected googlePatternNumberFormatter: GooglePatternNumberFormatter
    ) {
        this.activatedRoute.data.map((data) => {
            return data.storeConfigurations;
        }).subscribe(data => {
            if (
                data['google-adwords-conversion-sent-to'] !== undefined
                && data['google-adwords-conversion-sent-to'] !== null
            ) {
                this.sendTo = data['google-adwords-conversion-sent-to'];
            }
        });
    }

    ngOnInit() {
        if (null !== this.sendTo) {

            const formattedValue        = this.googlePatternNumberFormatter.transform(this.offer.total);
            const safeFormattedValue    = formattedValue ? formattedValue.replace(/[^\d,.-]/g, '') : '';
            const numericValue          = Number(safeFormattedValue.replace(',', '.'));

            this.conversionData = {
                'send_to': this.sendTo,
                'transaction_id': this.offer.id,
                'value': numericValue,
                'currency': 'BRL'
            };
        }
    }
}




// WEBPACK FOOTER //
// /codebuild/output/src3048926480/src/src/app/shared/components/google-adwords-conversion/google-adwords-conversion.component.ts